import React from 'react';
import { Box, Switch, Typography, Tooltip, Paper } from '@mui/material';
import { Science as ScienceIcon, Person as PersonIcon } from '@mui/icons-material';
import { useFounderMode } from './FounderModeContext';

/**
 * Mode Toggle Switch - Switches between Analyst and Founder modes
 * 
 * In Analyst mode: Technical terms (Churn Rate, CAC, ROI)
 * In Founder mode: Plain English (Customer Drop-off, Cost to buy a Customer, Money Multiplier)
 */
const ModeToggle: React.FC = () => {
  const { mode, toggleMode } = useFounderMode();
  const isFounderMode = mode === 'founder';

  return (
    <Paper
      elevation={1}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 0.75,
        borderRadius: 3,
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <Tooltip title="Technical terms for analysts">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, opacity: isFounderMode ? 0.5 : 1 }}>
          <ScienceIcon fontSize="small" sx={{ color: isFounderMode ? 'grey.500' : 'primary.main' }} />
          <Typography variant="caption" sx={{ color: isFounderMode ? 'grey.500' : 'primary.main', fontWeight: 'bold' }}>
            Analyst
          </Typography>
        </Box>
      </Tooltip>

      <Switch
        checked={isFounderMode}
        onChange={toggleMode}
        size="small"
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': {
            color: '#10B981',
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#10B981',
          },
        }}
      />

      <Tooltip title="Plain English for business owners">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, opacity: isFounderMode ? 1 : 0.5 }}>
          <PersonIcon fontSize="small" sx={{ color: isFounderMode ? '#10B981' : 'grey.500' }} />
          <Typography variant="caption" sx={{ color: isFounderMode ? '#10B981' : 'grey.500', fontWeight: 'bold' }}>
            Founder
          </Typography>
        </Box>
      </Tooltip>
    </Paper>
  );
};

export default ModeToggle;
